/* sola-recently-viewed.js — tracks PDP views in localStorage and hydrates the
 * "Recently viewed" row (snippets/sola-recently-viewed.liquid) with IN-STOCK products
 * only, via /products/{handle}.js. No backend, no personal data leaves the browser.
 */
(function () {
  if (window.__solaRV) return; window.__solaRV = true;

  var KEY = 'sola:rv';
  var MAX_STORED = 24;
  var MAX_FETCH = 12;
  var MAX_SHOWN = 8;
  var NEW_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function save(handles) {
    try { localStorage.setItem(KEY, JSON.stringify(handles.slice(0, MAX_STORED))); } catch (e) {}
  }
  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init() {
    var shell = document.querySelector('[data-sola-rv]');
    if (!shell) return;

    var current = shell.getAttribute('data-rv-current') || null;
    var handles = load();
    if (current) {
      handles = [current].concat(handles.filter(function (h) { return h !== current; }));
      save(handles);
    }

    var toFetch = handles.filter(function (h) { return h !== current; }).slice(0, MAX_FETCH);
    if (!toFetch.length) return;

    Promise.all(toFetch.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var list = shell.querySelector('[data-rv-list]');
      var tpl = shell.querySelector('template[data-rv-card]');
      if (!list || !tpl) return;

      var shown = 0;
      products.forEach(function (p) {
        if (!p || !p.available || shown >= MAX_SHOWN) return;
        var card = tpl.content.firstElementChild.cloneNode(true);
        card.href = p.url;
        var img = card.querySelector('.sola-card__img');
        if (p.featured_image) {
          img.src = p.featured_image + (p.featured_image.indexOf('?') < 0 ? '?width=480' : '&width=480');
          img.alt = p.title;
        } else { img.remove(); }
        var isNew = (p.tags || []).indexOf('new') >= 0 ||
          (p.created_at && (Date.now() - new Date(p.created_at).getTime()) < NEW_WINDOW_MS);
        if (isNew) card.querySelector('.sola-card__tag').hidden = false;
        card.querySelector('.sola-card__title').textContent = p.title;
        var priceVaries = p.price_min !== p.price_max;
        card.querySelector('.sola-card__price').textContent = (priceVaries ? 'From ' : '') + money(p.price_min != null ? p.price_min : p.price);
        list.appendChild(card);
        shown++;
      });
      if (shown > 0) {
        shell.hidden = false;
        if (window.posthog && posthog.capture) posthog.capture('recently_viewed_shown', { count: shown });
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
